import { BusinessApi } from 'shared/api';
import { ICreatePointDto } from 'shared/api/business/interfaces/create-point-dto.interface';

export const createPoint = async (
  requestData: ICreatePointDto
): Promise<string> => {
  const response: any = await BusinessApi.createPoint(requestData);
  const data = response.data;
  if (data == null) return '';
  if (typeof data === 'string') return data;
  if (typeof data === 'number') return String(data);
  const id = data.id ?? data.pointId ?? '';
  return typeof id === 'string' ? id : String(id);
};
